import React from "react";
import * as ContextMenuPrimitive from "@radix-ui/react-context-menu";

interface ContextMenuTriggerProps {
  children: React.ReactNode;
  isDisabled?: boolean;
  shouldOpenContextMenuByLeftClick?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export const ContextMenuTrigger = ({
  children,
  isDisabled,
  className,
  style,
  shouldOpenContextMenuByLeftClick,
}: ContextMenuTriggerProps) => {
  const handleLeftClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const contextMenuEvent = new MouseEvent("contextmenu", {
      bubbles: true,
      cancelable: true,
      clientX: e.clientX,
      clientY: e.clientY,
    });
    e.currentTarget.dispatchEvent(contextMenuEvent);
  };

  return (
    <ContextMenuPrimitive.Trigger
      disabled={isDisabled}
      className={className}
      style={style}
      onClick={shouldOpenContextMenuByLeftClick ? handleLeftClick : undefined}
    >
      {children}
    </ContextMenuPrimitive.Trigger>
  );
};
